<template>
  <div>
    <a
      class="text-gray-600 block"
      href="#pablo"
      ref="btnDropdownRef"
      v-on:click="toggleDropdown($event)"
    >
      <div class="items-center flex">
        <span
          class="w-12 h-12 text-sm text-white bg-gray-300 inline-flex items-center justify-center rounded-full"
        >
          <img
            alt="..."
            class="w-full rounded-full align-middle border-none shadow-lg"
            :src="currentUser.avatar"
          />
        </span>
      </div>
    </a>
    <div
      ref="popoverDropdownRef"
      class="bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48"
      v-bind:class="{
        hidden: !dropdownPopoverShow,
        block: dropdownPopoverShow,
      }"
    >
      <router-link
        to="/admin"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800"
      >
        Dashboard
      </router-link>
      <div class="h-0 my-2 border border-solid border-gray-200" />
      <a
        @click.prevent="logOut"
        href="javascript:void(0);"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800"
      >
        Log out
      </a>
    </div>
  </div>
</template>

<script>
/* 
  Class: UserDropdown
  Description: This class representing a dropdown with authenticated user actions.
*/

/* Imports */
import { createPopper } from "@popperjs/core";
/* /Imports/ */

export default {
  /* 
    Define data with custom dropdown state values. 
  */
  data() {
    return {
      dropdownPopoverShow: false,
    };
  },

  /* 
    Define computed properties to obtain different getters and setters and save them into the instance. 
  */
  computed: {
    /* 
      Obtain current user object from the store. 
    */
    currentUser() {
      return this.$store.state.auth.user;
    },
  },

  /* 
    Define methods for separate different logic. 
  */
  methods: {
    /* 
      Call store which dispatch logout action of user.
    */
    logOut() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },

    /* 
      Toggle dropdown when user clicked on profile avatar.
    */
    toggleDropdown: function (event) {
      event.preventDefault();
      
      if (this.dropdownPopoverShow) {
        this.dropdownPopoverShow = false;
      } else {
        this.dropdownPopoverShow = true;
        createPopper(this.$refs.btnDropdownRef, this.$refs.popoverDropdownRef, {
          placement: "bottom-start",
        });
      }
    },
  },

  /* 
    Check if user is authenticated.
  */
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }
  },
};
</script>